export function isBrowserEnvironment() {
  return typeof window !== `undefined`;
}

export function isStandalone() {
  return typeof mp === `undefined`;
}
